import Api from "../../helpers/api";
import Locations from "../../helpers/locations";
import Constants from "./OurDoctorConstant";

export const getAllDoctors = () => {

  return function(dispatch) {
    const successCall = (response) => {
      dispatch({
          type: Constants.ACTIONS.GET_ALL_DOCTORS_SUCCESS,
          payload: response.results
      });
    };

    const errorCall = (errorResponse) => {
      console.log(errorResponse);
      // dispatch({
      //     type: Constants.ACTIONS.POST_QUESTIONS_DATA_FAILED,
      //     payload: errorResponse
      // });
    };

    Api.doGet(Locations.ourDoctors,{},successCall, errorCall);
  };
};

export default {
  getAllDoctors
};
